import { useSyncExternalStore } from 'react';

import { getSystemTheme } from '@/core/utils/theme';

const QUERY = '(prefers-color-scheme: dark)';

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}

/** The OS color scheme, live — independent of the app's theme setting. */
export function useSystemTheme(): 'light' | 'dark' {
  return useSyncExternalStore(subscribe, getSystemTheme, () => 'light');
}
